// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"1a59b50d","428":"1f798993","549":"d7b904ca"}[chunkId] + ".chunk.js";
};